import React from "react";
import TabsNavigator from "components/TabsNavigator";
import PageShell from "components/bento/PageShell";
import NewCustomer from "./newCustomer";
import CustomerList from "./customerList";

const Customers = () => {
  const tabItems = [
    {
      text: "New Customer",
      component: <NewCustomer />,
      slug: "customers/new",
    },
    {
      text: "Customer list",
      component: <CustomerList />,
      slug: "customers/list",
    },
  ];

  return (
    <PageShell title="Customers">
      <TabsNavigator tabItems={tabItems} pageSlug="customers" />
    </PageShell>
  );
};

export default Customers;
